



























































































































































import { Vue, Component } from "vue-property-decorator";
import { Act as IAct } from "@/api/models/act";
import { ActEdit as IActEdit } from "@/api/models/act-edit";
import { Contract as IContract } from "@/api/models/contract";
import { Employee as IEmployee } from "@/api/models/employee";
import { Contractor as IContractor } from "@/api/models/contractor";
import { User as IUser } from "@/api/models/user";
import api from "@/getinfo-api";
import { isRoot } from "@/plugins/roles";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import DocumentArchiveButton from "@/components/form/DocumentArchiveButton.vue";
import { generatePdf } from "@/utils/files-helper";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import store from "@/store";
import DocTemplateGenerateV2 from "@/components/doc-tempates/DocTemplateGenerateV2.vue";

// TODO: слишком много ассинохронных запросов, переделать после добавление полей на бэке
@Component({
  components: {
    DocTemplateGenerateV2,
    DocumentArchiveButton,
    EntityFiles,
    TextField,
    CBlock,
    CBreadCrumbs,
  }
})
export default class ActView extends Vue {
  act!: IAct;
  contract!: IContract;
  responsible!: IEmployee;
  contractor!: IContractor;
  contractorUser!: IUser;
  isLoadingFiles: boolean = false;
  data() {
    return {
      act: undefined,
      contract: undefined,
      responsible: undefined,
      contractor: undefined,
      contractorUser: undefined
    };
  }

  async _generatePdf(file: any) {
    this.isLoadingFiles = true;
    const response = await generatePdf(file)
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        const { message } = err;
        this.$bvToast.toast(message, {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        });
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
    this.addFiles([response.id], true);
  }

  addFiles(files: any, fromDocTemplate: boolean = false) {
    let params: IActEdit = {
      contractId: this.act.contractId,
      number: this.act.number,
      responsibleId: this.act.responsibleId!,
      learningResources: this.act.learningResources,
      signedAt: this.act.signedAt,
      formedAt: this.act.formedAt,
      fileIds:
        this.act.files && fromDocTemplate
          ? [...this.act.files.map((el: any) => el.id), ...files]
          : [...files],
      price: this.act.price
    };

    this.isLoadingFiles = true;

    api.ActApi.edit(this.act.id, params)
      .then((res: { data: IAct }) => {
        this.act = res.data;
      })
      .finally(() => {
        this.isLoadingFiles = false;
      });
  }

  changeArchiveState(archive: boolean) {
    this.act.archive = archive;
  }

  get companyTitle() {
    return store.getters.selectedCompany.title;
  }

  async getActInfo() {
    try {
      let actResponse = await api.ActApi.get(this.$route.params.actId);
      this.act = actResponse.data;
      document.title = `${this.$t(
        this.$translate.CertificateOfCompletedWorks
      )} ${this.act.number} | ${this.companyTitle ?? ""}`;
      let contractResponse = await api.ContractApi.get(this.act.contractId);
      this.contract = contractResponse.data;
      let responsibleResponse = await api.EmployeeApi.get(
        this.contract.companyId,
        //@ts-ignore
        this.act.responsibleId
      );
      this.responsible = responsibleResponse.data;
      if (this.contract.clientId) {
        try {
          let contractorResponse = await api.ContractorApi.get(
            this.contract.clientId
          );
          this.contractor = contractorResponse.data;
        } catch (err) {
          let contractorUserResponse = await api.UsersApi.get(
            this.contract.clientId
          );
          this.contractorUser = contractorUserResponse.data;
        }
      }
    } catch (err) {
      if (err.response.status === 403)
        await this.$router.push({ name: "error" });
    }
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "acts" },
        label: this.$tc(this.$translate.CertificatesOfCompletedWorks)
      },
      {
        label: this.act.number
      }
    ];
  }

  get root() {
    return isRoot();
  }

  mounted() {
    this.getActInfo();
  }
}
